// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://desen.nbg1.your-objectstorage.com/public';
const server = "https://apidesen.mansolutions.app";
const port = 443;
const domain = "desen.mansolutions.app";
export { server, port, domain, serverImg };
